import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRightIcon, StarIcon } from 'lucide-react';
import { useCart } from '../../contexts/CartContext';
import { getProduct } from '../../utils/products';
import { formatPrice } from '../../utils/currency';
import { images } from '../../data/images';
import type { Product } from '../../types/product';
import { Reveal } from '../ui/Reveal';
const roles = ['Reinigen', 'Scrubben', 'Behandelen', 'Opfrissen', 'Voeden'];
export function RitualSetFeature() {
  const {
    add
  } = useCart();
  const set = getProduct('hammam-ritueel-set');
  if (!set) return null;
  const variant = set.variants[0];
  const items = (set.includes ?? []).map(slug => getProduct(slug)).filter((p): p is Product => Boolean(p));
  return <section className="bg-ink text-canvas" data-id="element-89" data-mp="ntuyx17dzawc">
      <div className="grid lg:grid-cols-2" data-id="element-90" data-mp="srmqtv816x0j">
        <div className="relative min-h-[460px] lg:min-h-[820px]" data-id="element-91" data-mp="ssoecz68hbz5">
          <img src={images.ritual} alt="Vrouw brengt rozenwater aan in een hammam-setting" className="absolute inset-0 h-full w-full object-cover" data-id="element-92" data-mp="xqznf7opfigb" />
          <div className="absolute bottom-5 left-5 flex items-center gap-3 rounded-2xl bg-white/95 p-2 pr-4 text-ink backdrop-blur" data-id="element-93" data-mp="2fsio9o2yvix8">
            <img src={set.image} alt="" className="h-14 w-14 rounded-xl object-cover" data-id="element-94" data-mp="26tox4d8enkr2" />
            <span className="text-sm" data-id="element-95" data-mp="21vdno3m0vc9d">
              <span className="block font-semibold" data-id="element-96" data-mp="21wf5cqxjmx02">5 producten</span>
              <span className="block text-muted" data-id="element-97" data-mp="2ylmjhdvu23ty">in één doos</span>
            </span>
          </div>
        </div>

        <div className="flex flex-col justify-center px-6 py-16 sm:px-12 lg:px-20 lg:py-24" data-id="element-98" data-mp="2ukubenyp64z9">
          <Reveal data-id="element-99" data-mp="2ps14pujo4mkj">
            <p className="flex items-center gap-2 text-sm text-canvas/70" data-id="element-100" data-mp="2prhxp8vk3ila">
              <StarIcon className="h-4 w-4 fill-blush text-blush" strokeWidth={0} data-id="element-101" data-mp="2kurg2h43sexr" />
              {set.rating.toLocaleString('nl-NL')} · {set.reviews} reviews · Bestseller
            </p>
            <h2 className="mt-5 text-4xl font-semibold leading-[0.98] tracking-display sm:text-6xl" data-id="element-102" data-mp="3di3ta0odjaee">
              Het hammam&shy;ritueel. <span className="text-blush" data-id="element-103" data-mp="at0r94msxuq">In één doos.</span>
            </h2>
            <p className="mt-5 max-w-md text-lg text-canvas/70" data-id="element-104" data-mp="58uhvoihyn3k">
              Vijf producten in de volgorde waarin je ze gebruikt. Geen gegok — je weet precies wat je doet en waarom.
            </p>
          </Reveal>

          <ol className="mt-10 border-t border-canvas/15" data-id="element-105" data-mp="3rmup8zjd0yas">
            {items.map((p, i) => <li key={p.slug} className="border-b border-canvas/15" data-id="element-106" data-mp="3dnmnpzzq5e3f" data-mpi={i}>
                <Link to={`/product/${p.slug}`} className="group flex items-center gap-5 py-4" data-id="element-107" data-mp="3io0m0qbix9o9">
                  <span className="w-6 text-sm text-canvas/40 tabular-nums" data-id="element-108" data-mp="34o7yf3van9ki">0{i + 1}</span>
                  <span className="flex-1 text-lg font-medium transition-colors duration-150 group-hover:text-blush" data-id="element-109" data-mp="38p1ljv0wwkcc">{p.name}</span>
                  <span className="text-sm text-canvas/50" data-id="element-110" data-mp="12xeg48tx8e8t">{roles[i]}</span>
                  <ArrowUpRightIcon className="h-4 w-4 text-canvas/40 transition-colors duration-150 group-hover:text-blush" data-id="element-111" data-mp="16yggiszkqwcd" />
                </Link>
              </li>)}
          </ol>

          <div className="mt-10 flex flex-wrap items-center gap-x-8 gap-y-6" data-id="element-112" data-mp="2nenh7czzghja">
            <p className="flex items-baseline gap-3" data-id="element-113" data-mp="2ncknahvpm49a">
              <span className="text-4xl font-semibold tracking-tight" data-id="element-114" data-mp="316k85dpx0le3">{formatPrice(variant.price)}</span>
              {variant.compareAt && <span className="text-canvas/50 line-through" data-id="element-115" data-mp="2wcz7fdwxtdb7">{formatPrice(variant.compareAt)}</span>}
            </p>
            <div className="flex flex-wrap gap-3" data-id="element-116" data-mp="3b5sx1s5xb9tl">
              <button onClick={() => add(set.slug, variant.id)} className="inline-flex h-14 items-center whitespace-nowrap rounded-full bg-canvas px-8 text-base font-medium text-ink transition-colors duration-150 hover:bg-blush" data-id="element-117" data-mp="3643lmbesgu4z">
                In winkelwagen
              </button>
              <Link to={`/product/${set.slug}`} className="inline-flex h-14 items-center whitespace-nowrap rounded-full border border-canvas/25 px-7 text-base font-medium transition-colors duration-150 hover:border-canvas" data-id="element-118" data-mp="1pspxjc9va65r">
                Bekijk de set
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}